import { useState, useEffect } from 'react';
import { PeptideApi } from '../../api/peptideApi';
import { errorToast, isCopanySuperOrSubAdmin } from '../../utils/helper';
import Loader from '../../component/common/Loader';
import OverviewStats from '../../component/peptide/OverviewStats';
import PauseCareStats from '../../component/peptide/PauseCareStats';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [pauseCareDashboardData, setPauseCareDashboardData] = useState(null);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      // Fetch APIs based on user type
      const [dashboardResponse, pauseCareDashboardRes] = await Promise.all([
        isCopanySuperOrSubAdmin()
          ? PeptideApi.getCompanyPeptideDashboardStats()
          : PeptideApi.getPeptideDashboardStats(),
        isCopanySuperOrSubAdmin()
          ? PeptideApi.getCompanyPauseCareDashboardStats()
          : PeptideApi.getPauseCareDashboardStats()
      ]);

      console.log('Dashboard Response:', dashboardResponse);
      console.log('Pause Care Dashboard Response:', pauseCareDashboardRes);

      if (dashboardResponse?.data?.meta?.code == 1) {
        setDashboardData(dashboardResponse.data.data);
      }

      if (pauseCareDashboardRes?.data?.meta?.code == 1) {
        setPauseCareDashboardData(pauseCareDashboardRes.data.data);
      }
    } catch (error) {
      errorToast(error.message || 'Failed to fetch dashboard data');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="p-6">
      {dashboardData && <OverviewStats overview={dashboardData} />}

      {pauseCareDashboardData && <PauseCareStats pauseCareData={pauseCareDashboardData} />}

      {!dashboardData && !pauseCareDashboardData && (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          <p className="text-gray-600 dark:text-gray-300 text-center">
            No dashboard data available
          </p>
        </div>
      )}

      {/* {dashboardData && (
        <>
          <CheckInsSummary checkInsSummary={dashboardData.check_ins_summary} />
          <UserEngagement userEngagement={dashboardData.user_engagement} />
          <PeptideAnalytics peptideAnalytics={dashboardData.peptide_analytics} />
          <HealthMetrics healthMetrics={dashboardData.health_metrics} />
          <SideEffects sideEffects={dashboardData.side_effects} />
          <TreatmentPreferences treatmentPreferences={dashboardData.treatment_preferences} />
        </>
      )} */}
    </div>
  );
};

export default Dashboard;
